import Get from '../Get';
import { Grid, Space } from '../../Layout';
import { Texts, Button } from '../../Object';
import { SetDate } from '../SetDate.js';
import { SetImg } from '../SetImg.js';
import { useDocumentLoadCompleted } from '../../Hooks';
import { Link } from 'react-router-dom';

const NewsList = (props) => {
  // Getオプション
  const args = {
    postType: "posts",
    perPage: props.perPage ? props.perPage : 3,
    page: props.page ? props.page : 1,
  };

  const isLoaded = useDocumentLoadCompleted();

  // post情報の取得
  const posts = Get(args);

  // 個別のエレメント情報
  const Item = (props) => {
    let post = {
      title: props.post.title.rendered, // タイトル
      id: props.post.id, // post id
      img: SetImg(props.post), // サムネイル
      date: SetDate(props.post.date), //　日付取得＆フォーマット
    };

    const gridProps = {
      wrap: {
        dir: "row",
        layout: "100%",
        size: ["324px", "100%"],
        gap: "24px",
      },
      body: {
        dir: "row",
        layout: "100%",
        size: "100%",
        gap: "16px",
      },
    };
    return (
      <>
        <Link to={`/post/${post.id}`}>
          <div className="p-post__hover">
            <Grid {...gridProps.wrap}>
              <img className='p-img__post' src={post.img} alt="media" />
              <Grid {...gridProps.body}>
                <p className="c-text--en c-text__min c-text--bold c-text--opacity5">
                  {post.date}
                </p>
                <p className="c-text--bold c-text__normal c-text__line-cut--single">
                  {post.title}
                </p>
              </Grid>
            </Grid>
          </div>
        </Link>
      </>
    );
  };

  const Loading = (props) => {
    return (
      <>
        <p>Loading...</p>
      </>
    );
  };

  let items = [];
  if (posts && isLoaded) {
    // post情報取得後
    items = posts.map((post, key) => {
      return <Item key={key} post={post} />;
    });
  } else {
    // post情報取得中
    items.push(<Loading></Loading>);
  }

  return (
    // 全体のエレメント
    <>
        {items}
    </>
  );
};

export default NewsList;